import { SparklesIcon } from 'lucide-react'

import { isDEV, isDEVDeploy } from '@/lib/constants'

import { AskNoahDisclaimer } from '@/features/ai/components/composer/ask-noah-disclaimer'

import {
	PromptInput,
	PromptInputFooter,
	PromptInputTextarea,
	PromptInputToolbar,
} from '@/components/ai-elements/prompt-input'
import { Pill } from '@/components/common/pill/pill'
import { Skeleton } from '@/components/ui/skeleton'

/**
 * `<Suspense>` fallback for the lazily-loaded `<AIRailPanelBody>` (P-21).
 *
 * Fills the rail (`h-full`, stable width) so the rare cold-open shows no layout
 * shift / blank flash (P-17 loading state). Prefetch-on-intent (see
 * `prefetchAIPanel` in `ai-rail-layout.tsx`) means this usually never paints.
 *
 * MUST NOT import anything in the lazy graph (`AIPanel`/`AIChat`/streamdown) or
 * the panel-body chunk collapses back into the eager bundle, defeating the split.
 */
export function AIRailPanelSkeleton() {
	return (
		<div className="flex h-full w-full min-w-0 flex-col" aria-busy>
			<header
				data-slot="ai-panel-header"
				className="border-border/60 bg-background flex h-12 shrink-0 items-center justify-between gap-2 border-b px-3"
			>
				<div className="flex min-w-0 items-center gap-2">
					<span
						aria-hidden
						className="bg-primary/10 text-primary inline-flex size-6 items-center justify-center rounded-md"
					>
						<SparklesIcon className="size-3.5" />
					</span>
					<h2 className="truncate text-sm font-semibold tracking-tight">
						Noah
					</h2>
					<Pill tone="pending">Beta</Pill>
				</div>
			</header>

			<div
				data-slot="ai-chat"
				className="flex h-full min-h-0 min-w-0 flex-1 flex-col"
			>
				<Skeleton className="min-h-0 w-full flex-1" />

				<div className="border-border/60 bg-background shrink-0 border-t p-3">
					<PromptInput onSubmit={() => {}}>
						<PromptInputTextarea disabled />

						<PromptInputFooter>
							{isDEVDeploy ||
								(isDEV && (
									<PromptInputToolbar>
										<Skeleton className="bg-foreground/20 h-6 w-10" />
										<Skeleton className="bg-foreground/20 size-6" />
									</PromptInputToolbar>
								))}

							<Skeleton className="bg-foreground/20 size-8" />
						</PromptInputFooter>
					</PromptInput>

					<AskNoahDisclaimer />
				</div>
			</div>
		</div>
	)
}
